import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";

export default async function searchGuests(
  eventId = '',
  scheduleId = '',
  group = '',
  status = 'all',
  search = '',
  limit = 10,
  offset = 0,
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/report/searchGuests?eventId=${eventId}&scheduleId=${scheduleId}&status=${status}&limit=${limit}&offset=${offset}`
        + (group ? `&group=${group}` : '')
        + (search ? `&search=${encodeURIComponent(search)}` : ''),
      headers: {
        "Content-Type": "application/json",
      },
    };
    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    return _ret.data.data;
  } catch (error) {
    console.log('Error searchGuests', error);
    throw error;
  }
}
